import React from "react";
import { useTranslation } from "react-i18next";
import AppLayout from "../../../navigation/Layout/Layout";
import useAuthSession from "../../../authPatient/hooks/useAuthSession";
import PaymentBoard from "../../components/PaymentBoard/PaymentBoard";
import { PATIENT_PLANS } from "../../config/plans.config";

export default function Plans() {
  const { t } = useTranslation();
  const { effectiveUserId } = useAuthSession({ auto: true });
  const userId = effectiveUserId || null;

  return (
    <AppLayout>
      <PaymentBoard
        plans={PATIENT_PLANS}
        userId={userId}
        userType="patient"
        title={t("payment.title")}
        subtitle={t("payment.subtitle")}
      />
    </AppLayout>
  );
}